'use strict';

var base = require('integrations/product/base');
var toastHelpers = require('core/components/toast');
var enrollmentHelpers = require('client_core/product/enrollments');

/**********
 * shared across QV and PDP
 */
function addToCart() {
    var scope = this;

    // if qty stepper input has focus, we need to blur it so product data can update before button click
    $(document).on('mouseenter', 'button.add-to-cart, button.add-to-cart-global', function (event) {
        var $button = $(event.target);
        var $container = $button.closest('.product-detail');
        if (!$container.length) {
            $container = $button.closest('.quick-view-dialog');
        }
        var $qtyStepperInput = $container.find('.quantity-stepper input');

        if ($qtyStepperInput.length && $qtyStepperInput.is(':focus')) {
            $qtyStepperInput.blur();
        }
    });

    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (event) {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        var quantity;

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            var $products = $(this).closest('.product-detail').find('.product-set-item-detail');
            if (!$products.length) {
                if ($(this).closest('.quick-view-dialog').length) {
                    $products = $(this).closest('.quick-view-dialog').find('.product-set-item-detail');
                } else {
                    $products = $('.product-detail');  // pagedesigner component 'Add all to cart btn' won't have .product-set-item-detail classes
                }
            }

            $products.each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: scope.methods.getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = scope.methods.getPidValue($(this));

        quantity = $(this).hasClass('single-variant-quick-add-to-cart') ? 1 : scope.methods.getQuantitySelected($(this));

        var $productContainer = $(this).closest('.product-detail, .product-tile');
        if (!$productContainer.length) {
            if ($(this).hasClass('single-variant-quick-add-to-cart')) {
                addToCartUrl = $(this).data('url');
            } else {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
                var $productModalbody = $(this).closest('.modal-content');
                addToCartUrl = scope.methods.getAddToCartUrl($productModalbody);
            }
        } else {
            addToCartUrl = scope.methods.getAddToCartUrl($productContainer);
        }

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: scope.methods.getChildProducts(),
            quantity: quantity,
            options: scope.methods.getOptions($productContainer)
        };

        // ISU update: add attendee list for enrollment products if valid or provide error messaging
        var isValidAttendeeList = enrollmentHelpers.validateAttendeeSelection(event.target);
        if (isValidAttendeeList) {
            form.attendees = $productContainer.find('.attendees-container textarea').val();
        } else {
            return;
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    if (!data.error) {
                        scope.methods.handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        $('body').trigger('product:afterAddToCartQuickview', data); //cart page quickview only
                        $.spinner().stop();
                        scope.methods.miniCartReportingUrl(data.reportingURL);
                    } else {
                        $.spinner().stop();
                        toastHelpers.methods.show('warning', data.message, false);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

function updatePdpForDigitalProducts() {
    $('body').on('product:afterAttributeSelect', (_event, attrData) => {
        const product = attrData.data.product;
        const isDigital = product?.itemType === 'digital' || false;
        const isFreeDigital = isDigital && product.price.sales.value === 0;
        const showDownloadOnPdp = product?.showDownloadOnPdp && product?.fileDownloadUrl !== '' || false;
        const $container = $(attrData.container).closest('.quick-view-dialog').length
            ? $(attrData.container).closest('.quick-view-dialog')
            : $(attrData.container).closest('.product-detail');

        // hide quantity field for free digital products
        if (isFreeDigital) {
            $container.find('.quantity').attr('data-digital', true);
            $container.find('.quantity').hide();
        } else {
            $container.find('.quantity').attr('data-digital', false);
            $container.find('.quantity').show();
        }

        // show download button for free epublications that have a download url
        if (showDownloadOnPdp) {
            $container.find('.prices-add-to-cart-actions').attr('data-show-download', true);
            $container.find('.download-on-pdp a').attr('href', product.fileDownloadUrl);
        } else {
            $container.find('.prices-add-to-cart-actions').attr('data-show-download', false);
        }
    });
}

function handleClickForDownloadOnPdp() {
    $('body').on('click', '.download-on-pdp .btn', (event) => {
        const $link = $(event.target).closest('.download-on-pdp').find('a');
        $link[0].click();
    });
}

base.addToCart = addToCart;
base.updatePdpForDigitalProducts = updatePdpForDigitalProducts;
base.handleClickForDownloadOnPdp = handleClickForDownloadOnPdp;

module.exports = base;
